import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from '@nolimitcity/slot-game/bin/core/resource/GameResources';
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from '@nolimitcity/slot-game/bin/core/stage/Orientation';
import {ScalableLayer} from '@nolimitcity/slot-game/bin/core/stage/ScalableLayer';
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {TimelineSprite} from '@nolimitcity/slot-launcher/bin/animation/TimelineSprite';
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {BarbarianFuryGameConfig} from '../../BarbarianFuryGameConfig';
import {BarbarianFurySoundConfig} from '../../BarbarianFurySoundConfig';
import {CoinsFountain} from "./CoinsFountain";

/**
 * Created by Ning Jiang on 2/7/2018.
 */

export class BarbarianFuryBigWinView extends BaseView {

    private _placeHolderText:PIXI.Sprite;
    private _isShowing:boolean = false;
    private _dimmer:PIXI.Graphics;
    private _coinsFountain:CoinsFountain;
    private _fireParticlesAnim:TimelineSprite;
    private _finalScaleLandscape:number = 0.7;
    private _finalScalePortrait:number = 0.65;
    private _bigWinLabelLayer:ScalableLayer;
    private _gameResizeData:IResizeData;
    private _bigWinParticles:TimelineSprite;

    private readonly _assetName:string = "bigWin/WIN_LEVEL_";
    private _fireAnim:TimelineSprite;
    private _layer:ScalableLayer;

    constructor() {
        super();
        this._layer = StageManager.getLayer(BarbarianFuryGameConfig.instance.LAYERS.BIG_WIN.name);
        this._coinsFountain = new CoinsFountain();
    }

    protected initAnimations():void {
        this._bigWinParticles = new TimelineSprite(GameResources.getTextures("bigWinParticles"));
        this._bigWinParticles.blendMode = PIXI.BLEND_MODES.ADD;
        this._bigWinLabelLayer = StageManager.getLayer(BarbarianFuryGameConfig.instance.LAYERS.BIG_WIN_LABEL.name);
        (this._fireParticlesAnim = new TimelineSprite(GameResources.getTextures("smokeFireParticles"), 20)).visible = false;
        this._fireParticlesAnim.blendMode = PIXI.BLEND_MODES.ADD;
        this._fireParticlesAnim.anchor.set(0.5, 0.5);
        this._dimmer = new PIXI.Graphics();
        this._dimmer.alpha = 0;
        this._layer.addChild(this._dimmer);
        this._layer.addChild(this._fireParticlesAnim);
        this._placeHolderText = new PIXI.Sprite(GameResources.getTextures(this._assetName + "0")[0]);
        this._placeHolderText.anchor.set(0.5);
        this._placeHolderText.alpha = 0;
        this._bigWinLabelLayer.addChild(this._placeHolderText);

        this._fireAnim = new TimelineSprite(GameResources.getTextures("bigWinFire"), 20);
        this._fireAnim.anchor.set(0.5);
        this._fireAnim.blendMode = PIXI.BLEND_MODES.ADD;
        this._bigWinLabelLayer.addChild(this._fireAnim);
        this._fireAnim.visible = false;
    }

    protected onResize(resizeData:IResizeData):void {
        this._gameResizeData = resizeData;
        if(!this._isShowing) {
            this._isResizeDirty = true;
            return;
        }

        this._isResizeDirty = false;

        this._dimmer.clear();
        this._dimmer.beginFill(0x000000, 0.8);
        this._dimmer.drawRect(0, 0, 1680, 1680);
        this._bigWinParticles.anchor.set(0.5);
        this._placeHolderText.x = BarbarianFuryGameConfig.instance.GAME_WIDTH / 2;
        this._bigWinParticles.x = BarbarianFuryGameConfig.instance.GAME_WIDTH / 2;
        this._fireAnim.x = BarbarianFuryGameConfig.instance.GAME_WIDTH / 2;
        if(resizeData.orientation === Orientation.LANDSCAPE) {
            this._bigWinLabelLayer.x = -280;
            this._bigWinLabelLayer.y = 0;
            this._placeHolderText.y = 200;
            this._fireAnim.y = 205;
            this._bigWinParticles.y = 220;
            this._placeHolderText.scale.set(this._finalScaleLandscape);
            this._fireParticlesAnim.position.set(BarbarianFuryGameConfig.instance.GAME_WIDTH / 2, 500);
        } else {
            this._bigWinLabelLayer.y = -280;
            this._bigWinLabelLayer.x = -280;
            this._fireAnim.y = (BarbarianFuryGameConfig.instance.GAME_HEIGHT) * 0.7;
            this._bigWinParticles.y = (BarbarianFuryGameConfig.instance.GAME_HEIGHT) * 0.7;
            this._placeHolderText.y = (BarbarianFuryGameConfig.instance.GAME_HEIGHT) * 0.7;
            this._placeHolderText.scale.set(this._finalScalePortrait);
            this._fireParticlesAnim.position.set(BarbarianFuryGameConfig.instance.GAME_WIDTH / 2, resizeData.height - this._fireParticlesAnim.height / 3);
        }
        this._layer.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);
    }

    public getBigWinLevelAnimation(winRatioConfig:IWinRatioConfig, level:number):Timeline {
        this._isShowing = true;
        if(this._isResizeDirty) {
            this.onResize(this._resizeData);
        }

        if(winRatioConfig.type === "bigWin") {
            SlotGame.sound.fadeAmbience(0, 500);
            SlotGame.sound.playEffect(BarbarianFurySoundConfig.instance.BIG_WIN);
            // #243
            this.onResize(this._gameResizeData);
        }
        this._fireParticlesAnim.visible = true;
        this._fireParticlesAnim.playLoop();
        this.setLandscapeAndPortraitValues(winRatioConfig.text!);
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._coinsFountain.startFountain(level);
                this.updateBigWinLevelAnimation(winRatioConfig.text!);
                this._placeHolderText.scale.set(0);
                TweenLite.to(this._placeHolderText.scale, 0.1, {
                    x : (this._gameResizeData!.orientation === Orientation.LANDSCAPE) ? this._finalScaleLandscape : this._finalScalePortrait,
                    y : (this._gameResizeData!.orientation === Orientation.LANDSCAPE) ? this._finalScaleLandscape : this._finalScalePortrait,
                    onComplete : () => {
                        this.playBigWinLabelAnimation();
                    }
                });
            },
            TweenLite.to(this._dimmer, 0.1, {alpha : 1}),
            TweenLite.to(this._placeHolderText, 0.01, {alpha : 1}),
            TweenLite.to(this._fireAnim, 0.01, {alpha : 1}),
            TweenLite.to(this._placeHolderText.scale, winRatioConfig.duration, {}),
        ]);

        return timeline;
    }

    /**
     * function to set variables value before next level transition started
     * @param winRatioConfig
     */
    private setLandscapeAndPortraitValues(winRatioConfig:string):void {
        if(winRatioConfig === "Big Win") {
            this._finalScaleLandscape = 1;
            this._finalScalePortrait = 0.9;
            this._fireAnim.scale.set(1.6, 0.7);
        } else if(winRatioConfig === "Mega Win") {
            this._finalScaleLandscape = 1;
            this._finalScalePortrait = 0.8;
            this._fireAnim.scale.set(1.75, 1);
        } else {
            this._finalScaleLandscape = 0.95;
            this._finalScalePortrait = 0.7;
            this._fireAnim.scale.set(2, 1);
        }
    }

    private playBigWinLabelAnimation():void {
        this._bigWinLabelLayer.addChildAt(this._bigWinParticles, 0);
        this._bigWinParticles.getAnimationAutoShowHide(true, true);
        this._bigWinParticles.scale.set((this._placeHolderText.scale.x + 0.1) * 2.38);
    }

    private updateBigWinLevelAnimation(text:string):void {
        switch(text) {
            case "Big Win":
                this._placeHolderText.texture = GameResources.getTextures(this._assetName + "0")[0];
                break;
            case "Mega Win":
                this._placeHolderText.texture = GameResources.getTextures(this._assetName + "1")[0];
                break;
            case "Super Mega Win":
                this._placeHolderText.texture = GameResources.getTextures(this._assetName + "2")[0];
                break;
            default:
                break;
        }
        this._fireAnim.visible = true;
        this._fireAnim.playLoop();
        this._isShowing = true;
    }

    public playEndingAnimation(endWinRatioConfig:IWinRatioConfig):void {
        SlotGame.sound.stopEffect(BarbarianFurySoundConfig.instance.BIG_WIN);
        SlotGame.sound.fadeAmbience(1, 2000);
        SlotGame.sound.playEffect(BarbarianFurySoundConfig.instance.BIG_WIN_END);
        this._isShowing = true;
        this.setLandscapeAndPortraitValues(endWinRatioConfig.text!); // calling this function to set values before ending animation
        this.onResize(this._gameResizeData); // calling this function to resolve bigwin shows in corner.
        this._fireParticlesAnim.visible = false;
        this._fireParticlesAnim.stopLoop();
        this._coinsFountain.stopFountain();
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this.updateBigWinLevelAnimation(endWinRatioConfig.text!);
            },
            TweenLite.fromTo(this._dimmer, 0.3, {alpha : 1}, {alpha : 0, delay : 0.5}),
            TweenLite.fromTo(this._placeHolderText, 0.3, {alpha : 1}, {alpha : 0, delay : 0.5}),
            TweenLite.fromTo(this._fireAnim, 0.3, {alpha : 1}, {alpha : 0, delay : 0.5}),
        ]);
        timeline.add(() => {
            this._isShowing = false;
            this._fireAnim.stopLoop();
            this._fireAnim.visible = false;
        });
        timeline.play();
    }
}